import React, { useEffect } from 'react';
import { Drawer, Form, Input, InputNumber, Select, Button } from 'antd';
import { SaveTtLocationConfigInput } from '../graphql/mutations/ttLocationConfigMutations';

// 仅允许创建 下一站/TEMU大箱码/承运商（及承运商下的服务子节点）。
// 屏蔽 始发地(1)/目的地(2)/TT业务类型(6) 的创建：前两者由仓库/系统维护；
// TT业务类型是后端固定枚举(FBT/CBT/UNLIMITED)、不可扩展，误加会导致建包选到后直接报错。
const LOCATION_TYPE_OPTIONS = [
  { label: '下一站', value: 3 },
  { label: 'TEMU大箱码', value: 4 },
  { label: '承运商', value: 5 },
];

type TtLocationConfigFormDrawerProps = {
  visible: boolean;
  onClose: () => void;
  onSubmit: (values: SaveTtLocationConfigInput) => Promise<void> | void;
  initialValues?: SaveTtLocationConfigInput;
  mode: 'create' | 'edit';
};

const TtLocationConfigFormDrawer: React.FC<TtLocationConfigFormDrawerProps> = ({
  visible,
  onClose,
  onSubmit,
  initialValues,
  mode,
}) => {
  const [form] = Form.useForm<SaveTtLocationConfigInput>();
  const isEdit = mode === 'edit';

  useEffect(() => {
    if (visible) {
      form.resetFields();
      if (initialValues) {
        form.setFieldsValue(initialValues);
      }
    }
  }, [visible, initialValues, form]);

  const handleFinish = async (values: SaveTtLocationConfigInput) => {
    // 排序可选：留空按 0 提交（后端 sortOrder 为非空 Int!，显式 null 会被拒）
    await onSubmit({ ...values, id: initialValues?.id, sortOrder: values.sortOrder ?? 0 });
  };

  return (
    <Drawer
      open={visible}
      width={560}
      onClose={onClose}
      title={isEdit ? '编辑分拣配置' : '新建分拣配置'}
      destroyOnClose
      footer={
        <div className="flex justify-end gap-2">
          <Button onClick={onClose}>取消</Button>
          <Button type="primary" onClick={() => form.submit()}>保存</Button>
        </div>
      }
    >
      <Form layout="vertical" form={form} onFinish={handleFinish}>
        <Form.Item
          label="配置类型"
          name="locationType"
          rules={[{ required: true, message: '请选择配置类型' }]}
        >
          <Select options={LOCATION_TYPE_OPTIONS} placeholder="请选择配置类型" />
        </Form.Item>

        <Form.Item label="父级ID" name="parentId">
          <InputNumber
            placeholder="父级ID（可选，尾程商服务需指向承运商记录）"
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item
          label="Code"
          name="code"
          rules={[{ required: true, message: '请输入 code' }]}
        >
          <Input placeholder="请输入 code（如尾程商服务码 USMPM）" />
        </Form.Item>

        <Form.Item
          label="名称"
          name="name"
          rules={[{ required: true, message: '请输入名称' }]}
        >
          <Input placeholder="请输入名称" />
        </Form.Item>

        <Form.Item label="Label Code" name="labelCode">
          <Input placeholder="包牌展示码（可选）" />
        </Form.Item>

        <Form.Item label="排序" name="sortOrder">
          <InputNumber placeholder="排序值（可选）" style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default TtLocationConfigFormDrawer;
